import Vue from 'vue'
import Vuex from 'vuex'

// import zhongkong from './modules/zhongkong'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    // zhongkong
  }
})
